import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
const ADMINISTRADOR = 1;
const EMPRESA = 2;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [MessageService]
})
export class LoginComponent implements OnInit {
  formLogin!: FormGroup;
  keepSignedIn = false;
  submitted = false;
  errorMsg = '';

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    if (this.auth.sessionActive()) this.router.navigate(['/productos-facturados']);
    this.formLogin = this.crearFormulario();
  }

  crearFormulario(): FormGroup {
    return this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });

  }
  // getters para validación más fácil en la plantilla
  get f() { return this.formLogin.controls; }

  onSubmit(): void {
    this.submitted = true;
    this.errorMsg = '';

    if (this.formLogin.invalid) {
      return;
    }

    const { email, password } = this.formLogin.value;
    this.auth.login(email, password).subscribe({
      next: (resp) => {

        // alert(resp.mensaje)
        if (resp.datos.fk_rol === EMPRESA) {

          this.auth.setNewSession(resp.datos);
          this.showSuccess(resp.mensaje);
          this.router.navigate(['/productos-facturados']);


        }
        if (resp.datos.fk_rol === ADMINISTRADOR) {

          this.auth.setNewSession(resp.datos);
          this.showSuccess(resp.mensaje);
          this.router.navigate(['/facturas']);


        }
      },
      error: err => {
        this.errorMsg = err.error?.mensaje || 'Ocurrió un error al iniciar sesión';
        this.showWarning(this.errorMsg)
      }
    });
  }



  registrar(): void {
    this.router.navigate(['/registrar']);
  }

  showSuccess(msg: string): void {
    this.messageService.add({ severity: 'success', summary: 'Éxito', detail: msg });
  }
  showWarning(msg: string): void {
    this.messageService.add({ severity: 'warn', summary: 'Nota!!', detail: msg });
  }
}
